module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/commons/svg-library/svgs/illustrations/payment-methods-affirm-98979d673bfa0a00a8d8c5666f0cddbb.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/svg-library/svgs/illustrations/payment-methods-affirm.svg
// module id = lZKk
// module chunks = 22 24 25